import React, { useState, useEffect } from 'react'
import api from '../../api';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';

function Section_6() {
    const userID = sessionStorage.getItem("RoleCode");
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false);

    const rawData = async () => {
        setLoading(true)
        try {
            const requestData = {
                login_user_id: userID,
                synceddatetime: "2023-01-24 11:57:34",
                FormCode: "314",
                ApiKey: "kavin",
                AppTypeNo: "3",
                AppVersion: "1.0.0"
            };
            const url = 'section_6_dashboard'
            const result = await api.get_Dashboard_Section(url, requestData);
            setData(result.responsemessage.household_dashboard_6)

        } catch (error) {
            console.error("Error fetching requested data:", error);
        } finally {
            setLoading(false)
        }
    };


    useEffect(() => {
        rawData();
    }, []);

    const DashboardCards = () => {

        const cardColors = {
  // 🏥 Healthcare section
  when_was_your_last_health: "#10b981", // Emerald
  Preferred_healthcare_facility: "#f97316", // Orange
  waiting_time_to_see_a_healthcare_provider: "#3b82f6", // Blue
  affordability_of_healthcare_services: "#ef4444", // Red
  can_you_afford_healthcare: "#8b5cf6", // Purple
  do_you_have_health_insurance: "#14b8a6", // Teal
  out_of_pocket_healthcare_expenditure: "#eab308", // Amber
  barriers_to_accessing_healthcare: "#6366f1", // Indigo
        }

        const cleanValue = (value) => {
            var new_str = ""
            for (var i = 0; i < value.length; i++) {
                if (value[i] == '$') {
                    new_str += ', '
                }else if(value[i] == '/'){
                    new_str += ' /'
                } else {
                    new_str += value[i]
                }
            }
            return new_str
        }

        const renderCardBlock = (label, key) => {
            const items = data[key];
            if (!Array.isArray(items) || items.length === 0) return null;
            
            const totalCount = items.reduce((sum, item) => sum + (item.count || 0), 0);
             const cardColor = cardColors[key] || "#4ca8db"; 


            return (
                <div className="bar text-600" key={key}>
                    <div>
                        <div className='flex justify-content-between align-items-center'>
                             <p className='w-9'>{label}</p>
                             <p>Total - {totalCount}</p>
                        </div>
                        <div className="grid flex align-items-center mb-2 headingCard" >
                            <div className="col-2"></div>
                            <div className="col-2">Count</div>
                            <div className="col-6 pl-8">Percentage</div>
                        </div>
                        {items.map((item, idx) => {
                            const nameKey = Object.keys(item).find(k => k !== 'count' && k !== 'percentage');
                            return (
                                <div className="grid flex align-items-center mt-2 f12" key={idx}>
                                    <div className="col-2">
                                        <span>{cleanValue(item[nameKey])}</span>
                                    </div>
                                    <div className="col-2">
                                        <span className='pl-1'>{item.count}</span>
                                    </div>
                                    <div className="col-6">
                                               <div
                    style={{
                      height: "8px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "10px",
                      overflow: "hidden",
                      position: "relative"
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        backgroundColor: cardColor,
                        width: `${parseFloat(item.percentage) || 0}%`,
                        borderRadius: "10px",
                        transition: "width 0.3s ease"
                      }}
                    />
                  </div>
                                    </div>
                                    <div className="col-2">
                                        <span>{item.percentage}%</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        };

        return (
            <div className='render-container'>

               <div className='middle-card'>
                <div style={{ flex: 1 }}>
                    {renderCardBlock("When was your last health check-up?", "when_was_your_last_health")}
                </div>
                <div style={{ flex: 1 }}>
                    {renderCardBlock("Preferred healthcare facility (Govt/Private)?", "Preferred_healthcare_facility")}
                </div>
                </div>
                <div className='middle-card'>
                <div style={{ flex: 1 }}>
                    {renderCardBlock("Waiting time to see a healthcare provider?", "waiting_time_to_see_a_healthcare_provider")}
                </div>
                <div style={{ flex: 1 }}>
                    {renderCardBlock("Affordability of healthcare services?", "affordability_of_healthcare_services")}
                </div>
                </div>
                <div className='middle-card'>
                <div style={{ flex: 1 }}>
                    {renderCardBlock("Can you afford healthcare when needed?", "can_you_afford_healthcare")}
                </div>
                <div style={{ flex: 1 }}>
                    {renderCardBlock("Do you have health insurance?", "do_you_have_health_insurance")}
                </div>
                </div>
                <div className='middle-card'>
                <div style={{ flex: 1 }}>
                    {renderCardBlock("Out-of-pocket healthcare expenditure?", "out_of_pocket_healthcare_expenditure")}
                </div>
                <div style={{ flex: 1 }}>
                    {renderCardBlock("Barriers to accessing healthcare?", "barriers_to_accessing_healthcare")}
                </div>
                </div>

               
            </div>
        )

    }

    return (
        <div>
            {loading && (
                <div className="backdrop">
                    <ProgressSpinner className='progressBar' />
                </div>
            )}

            <div className="gridDashboard bg-blue-50 pt-3">
                {data && <DashboardCards />}
            </div>
        </div>
    )
}

export default Section_6